import { useFiltersContext } from '../../../contexts';
import { LIST_TYPE_MENU_OPTION_ID_PREFIX } from '../constants';

export const useSelectedMenuOptionIds = () => {
  const { types } = useFiltersContext();

  const listTypeMenuOptionIds = types.map((type) => `${LIST_TYPE_MENU_OPTION_ID_PREFIX}${type}`);

  return [...(types.length ? listTypeMenuOptionIds : [])];
};
